import { Route, Routes } from '@angular/router';
import { PrestadoresContent } from './prestadores-content';
import { DashboardPrestadores } from '@/features/registro/prestadores/dashboard-prestadores/dashboard-prestadores';
import { prestadorRelatoriosRoutes } from '@/features/registro/prestadores/relatorios/prestador-relatorios.routes';
import { PRESTADORES_ABAS } from './prestadores.constants';
import { permissionGuard } from '@/core/permissions/permission.guard';

const rootPath = 'prestadores';

/**
 * Define as rotas do módulo de Prestadores:
 * - /prestadores: Rota principal que carrega o layout `PrestadoresContent`.
 * - Rota padrão ('') -> `DashboardPrestadores` (tela de busca; NÃO gateada)
 * - Rota 'relatorios' -> relatórios de Prestadores
 * - Uma rota por aba (`prestadores/<slug>`), com `data.codigo` estático e
 *   `permissionGuard` exigindo `PERMISSOES.prestadores.<func>.escopo`.
 */
const rotaAba = (slug: (typeof PRESTADORES_ABAS)[number]): Route => ({
    path: slug,
    component: DashboardPrestadores,
    canActivate: [permissionGuard],
    data: { codigo: slug, permission: { modulo: 'prestadores', funcionalidade: slug } }
});

export const prestadoresRoutes: Routes = [
    {
        path: rootPath,
        component: PrestadoresContent,
        children: [{ path: '', component: DashboardPrestadores }, ...prestadorRelatoriosRoutes, ...PRESTADORES_ABAS.map(rotaAba)]
    }
];
